import * as C from "./Customizing.styles";
import Layout from "../../layout/Layout";
import { useMemo, useRef, useState } from "react";
import { useEffect } from "react";
import { useRouter } from "next/router";
import Link from "next/link";
import {
  failAlert,
  succeedToSubmit,
  successAlert,
} from "../../../common/alert";
import {
  PackagingDeleteSet,
  PackagingInsertSet,
  PackagingListSet,
} from "../../../api/packagingBasket";
import * as yup from "yup";
import {
  closeConfirmModal,
  modifyConfirmModal,
  openConfirmModal,
} from "../../../redux/action/confirm";
import { connect } from "react-redux";
import { ItemCheckPackaging, PackagingApi } from "../../../api/packaging";
import * as _ from "lodash";
import { isLoaded, isLoading } from "../../../redux/action/loading";
import CustomizingSlider from "./CustomizingSlider";
import CustomizingCate from "./CustomizingCate";
import PortfolioSlider from "./PortfolioSlider";
import { priceComma } from "../../../common/splicePrice";
import { SeoMeta } from "@/utils/seo/SeoMeta";

const CustomizingProducts = ({
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoading,
  isLoaded,
  userInfo,
}) => {
  const router = useRouter();
  const customRef = useRef([]);

  // 유저 여부
  const isUser = useMemo(() => {
    if (userInfo?.Member?.ukey) {
      return true;
    } else {
      return false;
    }
  }, [userInfo]);

  // 유저 여부
  // 견적 바구니
  const [basketData, setBasketData] = useState([]);
  // 제작사례 & 포장재리뷰 리스트
  const [gallery, setGallery] = useState([]);

  // 제작사례 & 포장재리뷰 불러오기
  const fetchGallery = async () => {
    const body = {
      modes: "GalleryListSet",
    };
    const res = await PackagingApi(body);
    if (res.Code === "0000") {
      setGallery(res.Data?.Data);
    } else {
      console.error(res?.Data?.Msg);
    }
  };

  // 장바구니 리스트 불러오기
  const fetchCustomBasket = async () => {
    const body = {
      modes: "ListSet",
    };
    const res = await PackagingListSet(body);
    if (res.Code === "0000") {
      setBasketData(res.Data);
    }
  };

  // 장바구니 삭제
  const deleteBasketItem = async (id) => {
    const content = {
      title: "삭제하시겠습니까?",
      actionBtnLabel: "확인",
      actionBtnValid: true,
      cancelBtnLabel: "취소",
      onAction: async () => {
        const body = {
          modes: "DeleteSet",
          id: id,
        };
        const res = await PackagingDeleteSet(body);
        if (res.Code === "0000") {
          successAlert("삭제되었습니다.");
          fetchCustomBasket();
          closeConfirmModal();
        } else {
          failAlert("삭제에 실패했습니다.");
        }
      },
    };
    modifyConfirmModal(content);
    openConfirmModal();
  };

  useEffect(() => {
    fetchGallery();
    fetchCustomBasket();
  }, []);

  return (
    <>
      <Layout
        noBreadcrumb="d-none"
        parent="홈"
        sub={"맞춤제작"}
        subTitle={"견적요청"}
        pageTitle={SeoMeta.estimateRequest.title}
        pageDesc={SeoMeta.estimateRequest.description}
        pageKeyword={SeoMeta.estimateRequest.keywords}
      >
        <C.Container className="container">
          <C.Wrapper className="">
            {/* 배너 */}
            <CustomizingSlider />
            {/* 견적 바구니 */}
            <C.CustomCartWrapper>
              <h6
                onClick={() => {
                  router.push(
                    isUser ? "/customizing/customizing-cart" : "/login"
                  );
                }}
              >
                나의 견적바구니
              </h6>
              <div className="cart">
                <span>
                  {isUser
                    ? ` 현재 견적 바구니에 ${
                        basketData?.Count || 0
                      }개의 견적이 담겨있습니다.`
                    : "로그인 시 이용 가능합니다."}
                </span>
                <div className="icon">
                  <i className="fi-rs-shopping-bag" />
                  <span className="bag-count">{basketData?.Count || 0}</span>
                </div>
                <div className="hover-cart">
                  {basketData?.Rows?.map((el, i) => (
                    <div className="cart-row" key={i}>
                      <div className="cart-tumbnail">
                        <img src={el.image} />
                        <h6>{el.name}</h6>
                      </div>
                      <div className="cart-info">
                        <div className="info-box">
                          <div>
                            <span>수량 :</span>
                            <span>{priceComma(el.cnt)}</span>
                          </div>
                          <div>
                            <span>단가 :</span>
                            <span>
                              {el.price === "0"
                                ? "24시간 이내 견적"
                                : priceComma(el.price) + "원"}
                            </span>
                          </div>
                          <div>
                            <span>합계 :</span>
                            <span>
                              {el.price === "0"
                                ? "24시간 이내 견적"
                                : priceComma(
                                    Number(el.cnt) * Number(el.price)
                                  ) + "원"}
                            </span>
                          </div>
                        </div>
                        <div className="btn-box">
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={() => deleteBasketItem(el.id)}
                          >
                            삭제
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                  {!isUser ? (
                    <div className="d-flex flex-column">
                      <div
                        style={{
                          color: "#212529",
                          textAlign: "center",
                          marginBottom: "10px",
                        }}
                      >
                        로그인이 필요한 기능입니다.
                      </div>
                      <Link href={"/login"}>
                        <a className="btn btn-sm">로그인</a>
                      </Link>
                    </div>
                  ) : (
                    <div className="cart-btn">
                      <Link href={"/customizing/customizing-cart"}>
                        <a className="btn btn-sm">견적 바구니로 이동</a>
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </C.CustomCartWrapper>
            {/* 카테고리 선택 */}
            <CustomizingCate />
            <PortfolioSlider gallery={gallery} />
          </C.Wrapper>
        </C.Container>
      </Layout>
    </>
  );
};
const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});
const mapDispatchToProps = {
  openConfirmModal,
  modifyConfirmModal,
  closeConfirmModal,
  isLoading,
  isLoaded,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomizingProducts);
